// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"0a59a8fb","977":"afb7bd73"}[chunkId] + ".chunk.js";
};